import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import cn from 'classnames';

import Counter from './liveMenuCounter';
import FavouriteStar from '../favouriteStar/';
import Game from './liveMenuGame';


@withRouter
@inject('lineStore', 'routingStore')
@observer
class LiveMenuFavourites extends Component {
  constructor(props) {
    super(props);
  }

  selectItem = () => {
    if (this.props.lineStore.matchesList.matches.hasFavorite() ||
      this.props.lineStore.menu.favourites.games.length > 0 || this.props.lineStore.menu.favourites.popular.pop.length > 0) {
      // this.props.lineStore.menu.selectItem('fav', 0);
      this.props.history.push(`/${this.props.lineStore.mode}/favourites`);
    }
  }

  toggle = () => {
    this.props.lineStore.menu.toggleOpenItem(null, 0);
  }

  render() {
    const { favourites, isOpen, selected, mode, countFav } = this.props.lineStore.menu;
    const { shortMenu } = this.props.lineStore;
    const classNames = cn([
      'favourites-sport-item',
      { 'favourites-menu-item_active': selected.fav },
      { 'on': !isOpen.favourites },
    ]);

    return (
      <div className="favourites-menu-cont">
        <div className={classNames}>
          <FavouriteStar
            type={0}
            id="fav"
            disabled={shortMenu}
          />
          {Boolean(favourites.games.length) && mode === 'live' && (
            <button
              className={`favourites-sport-item-toggle ${!isOpen ? 'f-i-t-a' : ''}`}
              onClick={this.toggle}
            >
              <div>
                <span className="f-s-ico-arrow_buttom_1" />
              </div>
            </button>
          )}
          <button
            className="favourites-sport-item-a"
            onClick={this.selectItem}
          >
            <Counter count={countFav} />
            <div className="favourites-item-load-label">Избранное</div>
          </button>
          {isOpen.favourites && mode === 'live' && (
            <div className="favourites-league-wrapper">
              {favourites.games.map(o => (
                <Game
                  id={o}
                  key={o}
                  type={3}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default LiveMenuFavourites;


// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenuFavourites.jsx